import { themeProfiles } from "@/mocks/films";

const themeIcons: Record<string, string> = {
  family: "ri-home-heart-line",
  class: "ri-line-chart-line",
  history: "ri-history-line",
  freedom: "ri-lock-unlock-line",
  solitude: "ri-moon-line",
  identity: "ri-fingerprint-line",
  dignity: "ri-heart-pulse-line",
};

export default function ThemeSection() {
  return (
    <section id="themes" className="w-full bg-background-950">
      <div className="relative w-full h-[240px] md:h-[300px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20a%20projector%20casting%20warm%20light%20across%20a%20dark%20wooden%20table%2C%20muted%20amber%20and%20terracotta%20palette%2C%20soft%20dusty%20atmosphere%20with%20gentle%20film%20grain%2C%20quiet%20nostalgic%20editorial%20still%20life%2C%20shallow%20depth%20of%20field&width=1920&height=640&seq=ethfilm-band-01&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/35"></div>
        <div className="relative z-10 h-full w-full px-4 md:px-8 max-w-6xl mx-auto flex flex-col justify-center">
          <p className="max-w-2xl font-heading text-lg md:text-2xl font-bold leading-relaxed text-white">
            「伦理电影真正追问的，从来不是谁对谁错，<br className="hidden sm:block" />
            而是一个人在无法两全的处境里，愿意成为什么样的人。」
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-14 md:py-20 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-label tracking-[0.3em] text-accent-400 uppercase">Motifs</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-white">主题母题</h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-300">
            跨越国界，欧洲伦理电影反复回到同一批问题。下面七个母题，是理解这批作品时最常出现的入口，
            每个母题都对应着若干可以继续深入的代表作。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {themeProfiles.map((theme, i) => (
            <article
              key={theme.key}
              className="flex flex-col p-5 md:p-6 rounded-lg bg-background-900 border border-background-800 hover:border-accent-500 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-background-950">
                  <i className={`${themeIcons[theme.key] ?? "ri-question-line"} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="font-label text-2xl font-bold text-background-700">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-bold text-white">{theme.name}</h3>
              <p className="mt-0.5 text-xs font-label tracking-wide text-background-400 uppercase">{theme.en}</p>
              <p className="mt-3 text-sm leading-relaxed text-background-300 flex-1">{theme.description}</p>

              <div className="mt-4 pt-4 border-t border-background-800">
                <p className="text-xs text-background-400 mb-2">相关作品</p>
                <div className="flex flex-wrap gap-1.5">
                  {theme.films.map((f) => (
                    <span key={f} className="px-2 py-0.5 rounded bg-primary-900 text-primary-200 text-[11px]">
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}